/*
 * @Author: lbh
 * @Date: 2024-10-08 09:19:06
 * @LastEditors: Codex
 * @LastEditTime: 2026-04-16 13:05:00
 * @Description: storage
 */
const before = "app_ricepon_";

const storage = {
  restaurantId: {
    key() {
      return `${before}restaurant_Id`;
    },
    get() {
      return localStorage.getItem(this.key()) || "";
    },
    set(restaurandId) {
      localStorage.setItem(this.key(), restaurandId || "");
    },
    clear() {
      localStorage.removeItem(this.key());
    },
  },
  qrcode: {
    key(_) {
      let menuType = _ || storage.menuType.get();
      let restaurandId = storage.restaurantId.get();
      return `${before}qrcode_${menuType}_${restaurandId}`;
    },
    get(_) {
      let menuType = _ || storage.menuType.get();
      if (menuType == 2 || menuType == 4) {
        return localStorage.getItem(this.key(_)) || "";
      }
      return "";
    },
    set(qrcode, _) {
      localStorage.setItem(this.key(_), qrcode);
    },
    clear() {
      localStorage.removeItem(this.key());
    },
  },
  menuType: {
    key() {
      let restaurandId = storage.restaurantId.get();
      return `${before}menu_type_${restaurandId}`;
    },
    get() {
      return localStorage.getItem(this.key()) || "";
    },
    set(menuType) {
      localStorage.setItem(this.key(), menuType);
    },
    clear() {
      localStorage.removeItem(this.key());
    },
  },
  shopCart: {
    key(_) {
      let restaurantId = storage.restaurantId.get();
      let menuType = _ || storage.menuType.get();
      let qrcode = storage.qrcode.get(_, menuType);
      return `${before}shop_cart_${restaurantId}_${qrcode || menuType}`;
    },
    get(menuType) {
      let key = this.key(menuType);
      return JSON.parse(localStorage.getItem(key)) || [];
    },
    set(data, menuType) {
      let key = this.key(menuType);
      localStorage.setItem(key, JSON.stringify(data));
    },
    clear(menuType) {
      localStorage.removeItem(this.key(menuType));
    },
  },
  person: {
    key() {
      return `${before}person`;
    },
    get() {
      return localStorage.getItem(this.key()) || 1;
    },
    set(person) {
      localStorage.setItem(this.key(), person);
    },
    clear() {
      localStorage.removeItem(this.key());
    },
  },
  smsRegisterParams: {
    key() {
      return `${before}smsRegisterParams`;
    },
    get() {
      return JSON.parse(sessionStorage.getItem(this.key()) || "{}");
    },
    set(params) {
      sessionStorage.setItem(this.key(), JSON.stringify(params || {}));
    },
    clear() {
      sessionStorage.removeItem(this.key());
    },
  },
  googleLoginParams: {
    key() {
      return `${before}googleLoginParams`;
    },
    get() {
      return JSON.parse(sessionStorage.getItem(this.key()) || "{}");
    },
    set(params) {
      sessionStorage.setItem(this.key(), JSON.stringify(params || {}));
    },
    clear() {
      sessionStorage.removeItem(this.key());
    },
  },
  googleLoginCallback: {
    key() {
      return `${before}googleLoginCallback`;
    },
    get() {
      return JSON.parse(sessionStorage.getItem(this.key()) || "{}");
    },
    set(params) {
      sessionStorage.setItem(this.key(), JSON.stringify(params || {}));
    },
    clear() {
      sessionStorage.removeItem(this.key());
    },
  },
  googleRedirectContext: {
    key() {
      return `${before}googleRedirectContext`;
    },
    get() {
      return JSON.parse(localStorage.getItem(this.key()) || "{}");
    },
    set(params) {
      localStorage.setItem(this.key(), JSON.stringify(params || {}));
    },
    clear() {
      localStorage.removeItem(this.key());
    },
  },
};

export const _ = storage;

export default {
  install(app) {
    app.prototype.$storage = storage;
  },
};
